import React from 'react';

const PaginationControls = ({ currentPage, totalPages, handlePageChange, rowsPerPage, handleRowsPerPageChange }) => {
    const maxVisiblePages = 3; // The number of pages visible around the current page

    // Function to calculate visible page numbers
    const calculatePages = () => {
        let pages = [];

        // Always show the first page
        pages.push(1);

        // Calculate range of pages to show around the current page
        const startPage = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2) + 1);
        const endPage = Math.min(totalPages - 1, currentPage + Math.floor(maxVisiblePages / 2) + 1);

        // Add spacer if necessary
        if (startPage > 2) {
            pages.push('...');
        }

        // Add pages around the current page
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        // Add spacer if necessary before the last page
        if (endPage < totalPages - 1) {
            pages.push('...');
        }

        // Always show the last page if totalPages > 1
        if (totalPages > 1) {
            pages.push(totalPages);
        }

        return pages;
    };

    const pages = calculatePages();

    return (
        <div className="flex justify-between mt-4">
            <div className="flex space-x-2">
                {/* Previous Button */}
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 0} // Disable if on the first page
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-100 disabled:bg-gray-200 disabled:cursor-not-allowed"
                >
                    🠈
                </button>

                {/* Page Numbers */}
                <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                    {pages.map((page, index) => (
                        <button
                            key={index}
                            onClick={() => page !== '...' && handlePageChange(page - 1)} // Only change page if not spacer
                            className={`px-3 py-2 border-x ${
                                page - 1 === currentPage
                                    ? 'border-sss-blue bg-sss-blue text-white font-semibold'
                                    : page === '...'
                                    ? 'bg-gray-200' // Style the spacer (ellipses)
                                    : 'bg-white hover:bg-gray-100'
                            }`}
                            disabled={page === '...'}
                        >
                            {page}
                        </button>
                    ))}
                </div>

                {/* Next Button */}
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage + 1 === totalPages} // Disable if on the last page
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-100 disabled:bg-gray-200 disabled:cursor-not-allowed"
                >
                    🠊
                </button>
            </div>

            {/* Rows Per Page Dropdown */}
            <div className="flex items-center">
                <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="px-1 py-2 border border-sss-blue rounded-lg focus:border-sss-blue text-sss-blue-sel font-semibold focus:outline-none"
                >
                    <option value={10}>Rows per page: 10</option>
                    <option value={25}>Rows per page: 25</option>
                    <option value={50}>Rows per page: 50</option>
                    <option value={100}>Rows per page: 100</option>
                </select>
            </div>
        </div>
    );
};

export default PaginationControls;
